"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Product operations. */
var ProductImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Product class.
   * @param client Reference to the service client
   */
  function ProductImpl(client) {
    (0, _classCallCheck2["default"])(this, ProductImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[productCode, portalId])
   * @param portalId (Access Controlled)
   * @param productCode (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(ProductImpl, [{
    key: "get",
    value: function get(portalId, productCode, options) {
      var operationArguments = {
        portalId: portalId,
        productCode: productCode,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[productCode, portalId])
     * @param portalId (Access Controlled)
     * @param productCode (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getImage",
    value: function getImage(portalId, productCode, options) {
      var operationArguments = {
        portalId: portalId,
        productCode: productCode,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getImageOperationSpec);
    }
    /**
     *  (Auth: Authorize)
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getOrganizationPortalProductAccessForUser",
    value: function getOrganizationPortalProductAccessForUser(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getOrganizationPortalProductAccessForUserOperationSpec);
    }
  }]);
  return ProductImpl;
}(); // Operation Specifications


exports.ProductImpl = ProductImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getOperationSpec = {
  path: "/api/Portals({portalId})/Products/{productCode}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.ProductModel
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.productCode],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getImageOperationSpec = {
  path: "/api/Portals({portalId})/Products/{productCode}/Image",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.productCode],
  headerParameters: [Parameters.accept1],
  serializer: serializer
};
var getOrganizationPortalProductAccessForUserOperationSpec = {
  path: "/api/Portals({portalId})/GetOrganizationPortalProductAccessForUser",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ProductDropdownModel"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};